import {pageInfo, initPage, saveData,initUpdate, editData,deleteData,orderBasicDetailsInfo,selectFindInfoForSplit,submitForSplit, fileDownload,refuseApproved} from './../api';
import {selectOrderType} from "../../../../api";
const manualSplitting = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    orderBasicInfoObj :null,
    findSplitObj:null,
    splitSubmitObj: null,
    fileObj: null,
    orderTypeObj: null,
    refuseObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [item.isCanSplit == 'Y' ] }));
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
    FIND_SPLIT_DATA(state, data){
      state.findSplitObj = data.obj || {};
    },
    SPLIT_SUBMIT_DATA(state, data){
      state.splitSubmitObj = data || {};
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
    ORDER_TYPE(state,data){
      state.orderTypeObj = data.obj || {};
    },
    REFUSE_DATA(state, data) {
      state.refuseObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
    //订单拆分初始化
    async selectFindInfoForSplit({ commit }, obj) {
      let resp = await selectFindInfoForSplit(obj);
      commit('FIND_SPLIT_DATA', resp);
    },
    //订单拆分提交
    async submitForSplit({ commit }, obj) {
      let resp = await submitForSplit(obj);
      commit('SPLIT_SUBMIT_DATA', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
    async selectOrderType({commit}, obj){
      let resp = await selectOrderType(obj);
      commit('ORDER_TYPE', resp);
    },
    //拒绝
    async refuseApproved({ commit }, obj) {
      let resp = await refuseApproved(obj);
      commit('REFUSE_DATA', resp);
    },
  }
}
export default manualSplitting



// WEBPACK FOOTER //
// ./src/page/order/manualSplitting/store/manualSplitting.store.js